// extracted by mini-css-extract-plugin
export default {"root":"video-player_root__YXAud","isRadio":"video-player_isRadio__XOjFh"};